import { Payment } from '../models/Payment';
import {PaymentType} from '../enums/payment-type';
import { Practice } from '../models/Practice';
import { practiceHasFeature } from './practice-has-feature';
import { PaymentMethods } from '../enums/payment-methods';
import { PracticeFeature } from '../enums/practice-feature';

export function canPaymentBeRefunded(payment: Payment, practice: Practice): boolean {
    if (practice.paymentMethod == PaymentMethods.PROVET_PAY) {
        return false;
    }
  
    if (payment.type === PaymentType.ONLINE) {
      return false;
    }
    
    if (
        payment.invoiceId && 
        !practiceHasFeature(practice, PracticeFeature.ALLOW_REFUNDS_FOR_INVOICE_PAYMENTS) &&
        !practiceHasFeature(practice, PracticeFeature.RAISE_A_CREDIT_NOTE_FOR_INVOICE_REFUNDS)
    ) {
        return false;
    }

    if (payment.refundedAt) {
        return false;
    }

    if (payment.refundOfId) {
        return false;
    }

    if (payment.paidAt) {
        return true;
    }

    return false;
}
